import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";
import { Button } from "simplydo/react/ui";

import actions from "actions";
import { useAppDispatch, useAppSelector } from "store";

import { Banner } from "components/lib/UI";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HeaderArea = styled.div<{ $noVerticalPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  padding-top: ${({ $noVerticalPadding }) =>
    $noVerticalPadding ? "0" : "0.5rem"};
`;

const HeaderSpan = styled.div`
  color: #fff;
  font-weight: 700;
  opacity: 0.9;
`;

const HeaderMessage = styled.div`
  color: #fff;
  opacity: 0.8;
`;

type HomeHeaderProps = { compact?: boolean };

const HomeHeader = ({ compact }: HomeHeaderProps) => {
  const user = useAppSelector((state) => state.user);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  if (!user) return null;

  const ownerOrganisation = user.ownerOrganisation;
  const dashboardText = ownerOrganisation?.dashboardText;
  const onDashboardTextHidden = () => {
    dispatch(actions.user.hideDashboardText());
  };
  const onDashboardTextShow = () => {
    dispatch(actions.user.showDashboardText());
  };

  return (
    <Banner compact={compact}>
      <HeaderContainer>
        <HeaderArea>
          <h1>{t("home.welcome", { user })}</h1>
        </HeaderArea>
        <ActionContainer>
          <div style={{ textAlign: theme.sizes.isMobile ? "center" : "right" }}>
            <Button
              name="discover"
              size={theme.sizes.isMobile ? "tiny" : "medium"}
              inverted
              content={t("home.getStarted.discoverChallenges")}
              as={Link}
              to="/challenges/discover"
              style={compact ? {} : { marginRight: 20, marginBottom: 10 }}
            />
          </div>
        </ActionContainer>
      </HeaderContainer>
      {dashboardText && (
        <HeaderContainer>
          <HeaderArea $noVerticalPadding>
            <HeaderSpan>
              Message from {ownerOrganisation?.name}{" "}
              <span
                style={{
                  textDecorationLine: "underline",
                  cursor: "pointer",
                  fontSize: 12,
                  opacity: 0.6,
                }}
                onClick={
                  user.hideDashboardText
                    ? onDashboardTextShow
                    : onDashboardTextHidden
                }
              >
                {user.hideDashboardText ? "(Show)" : "(Hide)"}
              </span>
            </HeaderSpan>
            {!user.hideDashboardText ? (
              <HeaderMessage>{dashboardText}</HeaderMessage>
            ) : null}
          </HeaderArea>
        </HeaderContainer>
      )}
    </Banner>
  );
};

export default HomeHeader;
